import Vue from 'vue'

import {
  Button,

  Form,
  FormModel,
  Slider,
  Input,
  InputNumber,
  Checkbox,
  Radio,
  Select,
  Upload,

  Tooltip,

  Table,
  Tabs,

  Collapse,

  Pagination,

  Modal,
  Switch,
  Skeleton
} from 'ant-design-vue'

Vue.use(Button)

Vue.use(Form)
Vue.use(FormModel)
Vue.use(Slider)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Select)
Vue.use(Upload)

Vue.use(Tooltip)

Vue.use(Table)
Vue.use(Tabs)

Vue.use(Collapse)

Vue.use(Pagination)

Vue.use(Modal)
Vue.use(Switch)
Vue.use(Skeleton)